import { useMemo } from 'react';
export function useConnectDragSource(connector) {
  return useMemo(function () {
    return connector.hooks.dragSource();
  }, [connector]);
}
export function useConnectDragPreview(connector) {
  return useMemo(function () {
    return connector.hooks.dragPreview();
  }, [connector]);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd/dist/esm/hooks/useDrag/connectors.js
// module id = 1875
// module chunks = 0